import { type YakurekiDetail } from '@/shared/types/yakurekiCore'
import { type SoapContentItem } from '@/shared/types/yakurekiSoap'

import {
  ANYCOMPASS_TRANSFER_SECTION_ORDER,
  SOAP_SECTION_TO_SOUP_KBN,
} from '../constants/embed'
import { type KakeruFreeYkrkRow } from '../types/embed'

// AnyCOMPASS iframe への「転記」用に、生成 SOAP を親側フリー薬歴行の配列へ変換する。
//
// buildSoapCopyText と同じ採否 (is_selected) を起点にし、
// コピーと転記で薬剤師に渡る内容を一致させる(= 採用行のみ)。
// 並び(S→O→A→EP→CP→OP)を保ち、空行は落とす。
export const buildAnyCompassRows = (
  soaps: YakurekiDetail['soaps']
): KakeruFreeYkrkRow[] =>
  ANYCOMPASS_TRANSFER_SECTION_ORDER.flatMap((key) => {
    const items = (soaps?.[key] ?? []) as SoapContentItem[]
    return items
      .filter(
        (item) => item.content.trim() !== '' && (item.is_selected ?? true)
      )
      .map((item) => ({
        soupKbn: SOAP_SECTION_TO_SOUP_KBN[key],
        jskSidoBun: item.content,
      }))
  })
